import { SearchRepository } from '../../domain/interfaces/SearchRepository';
import { 
  TrendingVm, 
  ProductsVm, 
  SuggestionVm,
  toTrendingVM, 
  toProductsVM, 
  toSuggestionVM 
} from '../viewModels/search.app.vm';

// Type for the service returned by createSearchService
export type SearchService = ReturnType<typeof createSearchService>;

/**
 * Service returns granular application ViewModels
 * Presentation layer will combine them as needed
 */
export interface SearchSuggestionsAppVm {
  trending?: TrendingVm;
  suggestions: (string | SuggestionVm)[];
  products: ProductsVm;
  searchText?: string;
}

export function createSearchService(repo: SearchRepository) {
  return {
    async getSuggestions(query: string, allowEmpty = false): Promise<SearchSuggestionsAppVm> {
      const results = await repo.fetchSuggestions(query.trim(), allowEmpty);
      
      const suggestionsVm = results.suggestions.map(item => {
        if (typeof item === 'string') {
          return item;
        }
        return toSuggestionVM(item);
      });

      return {
        trending: results.trending ? toTrendingVM(results.trending) : undefined,
        suggestions: suggestionsVm,
        products: toProductsVM(results.products),
        searchText: results.searchText,
      };
    }
  };
}

// all logic should be in the service layer.